// extracted by mini-css-extract-plugin
export default {"newPhotosButton":"ScrollUpButton_newPhotosButton__FtlSJ","show":"ScrollUpButton_show__naz0V","hide":"ScrollUpButton_hide__wt9IJ"};